module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "grey",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Add New Role")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveRole()
      }
    }
  }, [_vm._v("Save Role")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "red",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.activeDialog()
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Role Title",
      "required": ""
    },
    model: {
      value: (_vm.roleTitle),
      callback: function($$v) {
        _vm.roleTitle = $$v
      },
      expression: "roleTitle"
    }
  }), _vm._v(" "), (!_vm.valid) ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("Title field is required")]) : _vm._e()], 1), _vm._v(" "), _c('v-subheader', [_vm._v("Events")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.events.create_event),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.events, "create_event", $$v)
      },
      expression: "newPriviledge.events.create_event"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Create Events")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create events")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Activity Stream")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.activity_stream.post_to_activity),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.activity_stream, "post_to_activity", $$v)
      },
      expression: "newPriviledge.activity_stream.post_to_activity"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Post to Activity Stream")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to create post in activity stream")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Economic Impact")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.giveAllAccessToEconomicImpact()
      }
    },
    model: {
      value: (_vm.newPriviledge.economic_impact.all_access),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.economic_impact, "all_access", $$v)
      },
      expression: "newPriviledge.economic_impact.all_access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("All Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give full access to the economic impact module")])], 1)], 1), _vm._v(" "), _vm._l((_vm.analysisList), function(analysis, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-action', [_c('v-checkbox', {
      attrs: {
        "readonly": ""
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.unCheckEconomicImpactAllAccess()
        }
      },
      model: {
        value: (_vm.newPriviledge.economic_impact[analysis.id]),
        callback: function($$v) {
          _vm.$set(_vm.newPriviledge.economic_impact, analysis.id, $$v)
        },
        expression: "newPriviledge.economic_impact[analysis.id]"
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(analysis.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Give access to the "), _c('span', {
      staticStyle: {
        "text-transform": "lowercase"
      }
    }, [_vm._v(_vm._s(analysis.text))])])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v("Chat")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.chat.group_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "group_chat", $$v)
      },
      expression: "newPriviledge.chat.group_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Group Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send messages in groups")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.newPriviledge.chat.private_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "private_chat", $$v)
      },
      expression: "newPriviledge.chat.private_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Private Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allow users to be able to send private messages across users")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.newPriviledge.chat.video_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "video_chat", $$v)
      },
      expression: "newPriviledge.chat.video_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Video Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to video chats")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    model: {
      value: (_vm.newPriviledge.chat.voice_chat),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.chat, "voice_chat", $$v)
      },
      expression: "newPriviledge.chat.voice_chat"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Voice Chats")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Enables users access to voice chats")])], 1)], 1)], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Email Updates")]), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-action', [_c('v-checkbox', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.newPriviledge.email_updates.access),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.email_updates, "access", $$v)
      },
      expression: "newPriviledge.email_updates.access"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Enable Access")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Allows users to receive email updates")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Set limit for Email Update")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Limit the number of email updates")])], 1), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.newPriviledge.email_updates.limit),
      callback: function($$v) {
        _vm.$set(_vm.newPriviledge.email_updates, "limit", $$v)
      },
      expression: "newPriviledge.email_updates.limit"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "5",
      "value": 5
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "10",
      "value": 10
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    attrs: {
      "flat": "",
      "color": "white",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon'), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.valid) ? _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("Title field is required")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "primary",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.saveRole()
      }
    }
  }, [_vm._v("Save Role")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "round": "",
      "color": "red",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.activeDialog()
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dcb5814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Priviledges/NewRole.vue
// module id = 1638
// module chunks = 10